import axios from 'axios';

const service = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://www.ogolden.com/',
  timeout: 15000,
});

// 在途请求计数：预渲染就绪信号（src/utils/prerenderSignal.ts）依赖这个数字
// 判断"当前没有请求在飞"。必须在成功与失败两条路径都递减，否则一旦某个请求
// 失败，计数会永久悬挂在 >0，预渲染信号永远不会置位。
let pendingRequestCount = 0;
const pendingCountListeners = new Set<(count: number) => void>();

function notifyPendingCountListeners() {
  pendingCountListeners.forEach(listener => listener(pendingRequestCount));
}

function incrementPendingRequestCount() {
  pendingRequestCount += 1;
  notifyPendingCountListeners();
}

function decrementPendingRequestCount() {
  pendingRequestCount = Math.max(0, pendingRequestCount - 1);
  notifyPendingCountListeners();
}

/** 读取当前在途请求数（同步快照） */
export function getPendingRequestCount(): number {
  return pendingRequestCount;
}

/**
 * 订阅在途请求数变化。返回取消订阅函数。
 * 订阅时会立即以当前值触发一次回调，方便订阅方初始化自身状态。
 */
export function onPendingRequestCountChange(
  listener: (count: number) => void,
): () => void {
  pendingCountListeners.add(listener);
  listener(pendingRequestCount);
  return () => {
    pendingCountListeners.delete(listener);
  };
}

// 请求拦截器：每发起一个请求即计数 +1。递增之后请求必然会经过下面的响应
// 拦截器（成功 resolve 或失败 reject 二者之一），计数在那里对称递减。
service.interceptors.request.use(config => {
  incrementPendingRequestCount();
  return config;
});

// 响应拦截器：统一错误处理（无JWT逻辑）+ 计数 -1（成功与失败路径都要递减）
service.interceptors.response.use(
  response => {
    decrementPendingRequestCount();
    return response.data;
  },
  error => {
    decrementPendingRequestCount();
    console.error('API请求失败:', error);
    return Promise.reject(error);
  }
);

export default service;
